<div class="teia-modal">
    <div class="td-cnt-ext">
        <div class="td-cnt-md">
            <div class="td-cnt-title">
                <span class="te-title">{{ 'enquiryBook.reopenEnquiry' | translate}}</span>
            </div>
            <div class="td-cnt-body">
                <ng-container *ngIf="isStepOne">
                    <p class="confirmation-message">{{ 'enquiryBook.reopenEnquiryConfirmMessage' | translate }}</p>
                </ng-container>

                <ng-container *ngIf="isStepTwo">
                    <!-- <p class="confirmation-message">{{ 'enquiryBook.editEnquiryConfirmMessage' | translate }}</p> -->
                    <div class="customer-date">
                        <teiasoft-datetime
                            [labelText]="'grid.CustomerRequestDate' | translate"
                            [isRequired]="true"
                            [isValid]="isCustomerRequestDateValid"
                            [isMobile]="isMobile"
                            [maxDate]="maxDate"
                            [value]="customerRequestDate ?? undefined"
                            [dateFormat]="globals.dateFormat!"
                            (onChange)="onCustomerRequestDateChange($event)">
                        </teiasoft-datetime>
                        <div *ngIf="!isCustomerRequestDateValid" class="error-message">
                            {{ 'errors.fieldMandatory' | translate }}
                        </div>
                    </div>
                </ng-container>
            </div>
            <div class="td-cnt-btn">
                <teiasoft-button (click)="onCloseClick()" [type]="'tb-cancel'" [text]="'commons.cancel' | translate"
                    class="mr-5"></teiasoft-button>

                <ng-container *ngIf="isStepOne">
                    <teiasoft-button (click)="onConfirmClick()" [type]="'tb-primary'" [text]="'commons.yes' | translate"
                        class="mr-5"></teiasoft-button>
                </ng-container>

                <ng-container *ngIf="isStepTwo">
                    <!-- <teiasoft-button (click)="onBackClick()" [type]="'tb-secondary'" [text]="'commons.previous' | translate"
                        class="mr-5"></teiasoft-button> -->
                    <teiasoft-button (click)="onSaveClick()" [type]="'tb-primary'" [text]="'commons.save' | translate"
                        class="mr-5" [disabled]="!customerRequestDate"></teiasoft-button>
                </ng-container>
            </div>
        </div>

    </div>
</div>
